var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-list-scroll"},[_c('div',{staticClass:"game-grid"},_vm._l((_vm.games),function(game,index){return _c('game-card',{key:game.id || game.link || index,attrs:{"game":game,"image-url":_vm.imageUrl,"query-string":_vm.queryString,"rank":index + 1}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }